import React, { useState, useEffect } from "react";
import {
  Button,
  CircularProgress,
  Grid,
  Paper,
  Typography,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Hidden,
  makeStyles,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import axios from "axios";
import { JSONEditor } from "./JSONEditor";
import { PDFViewer } from "./PDFViewer";
import { appUrl } from "../../../../../../../../utils/config";
import { fetchDSBatchDetails } from "../../../../../../containers/actions/common/saslAction";
import { useDispatch, useSelector } from "react-redux";
import { getFeaturesAccess } from "../../../../../../containers/actions/common/accessControl";
const useStyles = makeStyles((theme) => ({
  titleGrid: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "0.5rem",
    backgroundColor: "#f5f9ff",
    width: "100%",
  },
  closeText: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    cursor: "pointer",
    fontWeight: 500,
    "&:hover": {
      borderBottom: "2px solid red",
    },
  },
  icon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    cursor: "pointer",
    padding: "0.3rem",
  },
  title: {
    fontWeight: 500,
    [theme.breakpoints.down("xs")]: {
      fontSize: "0.875rem",
    },
  },
  subtitle: {
    fontWeight: 500,
    [theme.breakpoints.down("xs")]: {
      fontSize: "0.875rem",
    },
  },
  main: {
    textAlign: "center",
    alignItems: "center",
    justifyContent: "center",
  },
  children: {
    paddingTop: 40,
    // [theme.breakpoints.down('xs')]: {
    //   paddingTop:60,
    // },
  },
}));

const ViewStructuredInformationBox = (props) => {
  const {
    schrockenCustomFileID,
    open,
    onClose,
    batchDetails,
    structuredFiles, documentCategory
  } = props;
  const classes = useStyles();
  const dispatch = useDispatch();
  const {
    coaJSONOriginal,
    coaJSONEdited,
    vendorMosymphonyID,
    schrockenDeliveryScheduleBatchID,
  } = batchDetails;
  const { customFileName } = structuredFiles;
  //console.log(structuredFiles);
  const [coaData, setCoaData] = useState(
    coaJSONEdited
      ? coaJSONEdited //JSON.parse(coaJSONEdited)
      : coaJSONOriginal
        ? coaJSONOriginal //JSON.parse(coaJSONOriginal)
        : null
  );
  //   const [originalCoaData, setOriginalCoaData] = useState(coaJSONOriginal ? JSON.parse(coaJSONOriginal) : null);
  const [isEditing, setIsEditing] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [loadingStatus, setLoadingStatus] = useState("");
  const [isSaving, setIsSaving] = useState(false);
  const [error, setError] = useState(null);

  const [showOriginalBtn, setShowOriginalBtn] = useState(false)
  const [showEditedBtn, setShowEditedBtn] = useState(false)

  const screenAccess = useSelector(
    (state) =>
      state.pcmp.common.accessControl.screensAccess?.data?.fgBatch
  );

  const featuresAccess = useSelector(
    (state) =>
      state.pcmp.common.accessControl.featuresAccess?.fgBatchFeatures
  );

  useEffect(() => {
    if (screenAccess?.screenAccess && !featuresAccess)
      dispatch(getFeaturesAccess(screenAccess?.screenId, 'fgBatchFeatures'));
  }, [dispatch, screenAccess, featuresAccess]);

  const handleShowOriginal = () => {
    setShowOriginalBtn(true)
    setShowEditedBtn(false)
    setError(null);
    setCoaData(coaJSONOriginal ? coaJSONOriginal : null);
    setIsEditing(false);
  };

  const handleShowEdited = () => {
    setError(null);
    setShowOriginalBtn(false)
    setShowEditedBtn(true)
    setCoaData(coaJSONEdited ? JSON.parse(coaJSONEdited) : null);
    setIsEditing(false);
  };

  const handleSaveEdit = async () => {
    let data = {
      fileName: customFileName,
      fileType: "CoA",
      cdmoOrgID: vendorMosymphonyID,
      schrockenDeliveryScheduleBatchID: schrockenDeliveryScheduleBatchID,
      coaJSONOriginal: coaJSONOriginal,
      coaJSONEdited: coaData,
    };
    setIsSaving(true);
    setIsLoading(true);
    setError(null);
    axios
      .post(
        `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/workflow/handleDataExtractionEditedData`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
      .then((res) => {
        //console.log(res);
        setIsLoading(false);
        if (res.status) {
          // setCoaData(coaData);
          let data1 = {
            schrockenDeliveryScheduleBatchID: schrockenDeliveryScheduleBatchID,
          };
          dispatch(fetchDSBatchDetails(data1));
          setIsEditing(false);
          setIsSaving(false);
        }
      })
      .catch((err) => {
        console.error("Failed to save edits: ", err);
        setIsSaving(false);
        setIsLoading(false);
        setError(err.message);
      });

    // try {
    //   setIsSaving(true);
    //   setIsLoading(true);
    //   // throw new Error("New mock error");
    //   const response = await axios.post(
    //     `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/workflow/handleDataExtractionEditedData`,
    //     data,
    //     //JSON.stringify(postData),
    //     {
    //       headers: {
    //         "Content-Type": "application/json",
    //       },
    //     }
    //   );

    //   console.log(response);
    //   // setCoaData(coaData);
    //   setIsEditing(false);
    //   setIsSaving(false);
    //   setIsLoading(false);
    // } catch (err) {
    //   console.error("Failed to save edits: ", err);
    //   setIsSaving(false);
    //   setIsLoading(false);
    // }
  };

  return (
    <Dialog fullScreen open={open} onClose={onClose}>
      <DialogTitle disableTypography style={{ backgroundColor: "#f5f9ff" }}>
        <Grid container justifyContent="center" className={classes.titleGrid}>
          <Grid item xs={11} sm={11} md={11} className={classes.main}>
            <Typography variant="h4" className={classes.title}>
              {/* {`View Structured ${documentCategory}`} */}
              {`View Digitized ${documentCategory}`}
            </Typography>
          </Grid>

          <Grid item xs={1} sm={1} md={1}>
            <Hidden xsDown implementation="css">
              <Typography
                variant="body2"
                onClick={onClose}
                className={classes.closeText}
              >
                Cancel{" "}
                <CloseIcon
                  fontSize="large"
                  color="error"
                  className={classes.icon}
                />
              </Typography>
            </Hidden>
          </Grid>
        </Grid>
      </DialogTitle>

      <DialogContent>
        <Box mt={2}>
          <Grid container spacing={3}>
            {/* Left Panel - COA Data */}
            <Grid item xs={12} md={6}>
              <Paper elevation={3}>
                <Box
                  p={3}
                  display="flex"
                  justifyContent="space-between"
                  borderBottom={1}
                  borderColor="grey.300"
                >
                  <Typography variant="h6">{documentCategory} Data</Typography>
                  {coaData && !isLoading && (
                    <Box>
                      {isEditing ? (
                        <>
                          <Button
                            variant="contained"
                            color="default"
                            onClick={() => {
                              setCoaData(coaJSONOriginal);
                              setIsEditing(false);
                              setError(null);
                            }}
                            disabled={isSaving}
                            style={{ marginRight: 8 }}
                          >
                            Cancel
                          </Button>
                          <Button
                            variant="contained"
                            color="primary"
                            onClick={handleSaveEdit}
                            disabled={isSaving}
                            style={{ marginRight: 8 }}
                          >
                            {isSaving ? "Saving..." : "Save"}
                          </Button>
                        </>
                      ) : (
                        featuresAccess?.fgBatchEditDigitizedInformation &&
                        <Button
                          variant="contained"
                          color="secondary"
                          onClick={() => {
                            setShowOriginalBtn(false)
                            setShowEditedBtn(false)
                            setIsEditing(true)
                          }
                          }
                          style={{ marginRight: 8 }}
                        >
                          Edit
                        </Button>
                      )}
                      <Button
                        variant="contained"
                        color={showOriginalBtn ? "primary" : "default"}
                        onClick={handleShowOriginal}
                        style={{ marginRight: 8 }}
                      >
                        Show Original
                      </Button>
                      {coaJSONEdited && (
                        <Button
                          variant="contained"
                          color={showEditedBtn ? "primary" : "default"}
                          onClick={handleShowEdited}
                          style={{ marginRight: 8 }}
                        >
                          Show Edited
                        </Button>
                      )}
                    </Box>
                  )}
                </Box>
                {error && (
                  <Box
                    style={{
                      border: "2px solid rgb(255,0,0)",
                      backgroundColor: "rgb(255,240,240)",
                      Opacity: 1,
                      textAlign: "center",
                      padding: "0.8rem",
                      fontSize: "0.875rem",
                    }}
                  >
                    <Typography>
                      Something went wrong. Please try again later.
                    </Typography>
                  </Box>
                )}
                <Box p={3}>
                  {isLoading ? (
                    <Box
                      display="flex"
                      flexDirection="column"
                      alignItems="center"
                      justifyContent="center"
                    >
                      <CircularProgress color="primary" />
                      <Typography
                        variant="body2"
                        color="textSecondary"
                        style={{ marginTop: 16 }}
                      >
                        {loadingStatus || "Loading..."}
                      </Typography>
                    </Box>
                  ) : (
                    coaData && (
                      <JSONEditor
                        data={coaData}
                        isEditing={isEditing}
                        onChange={setCoaData}
                        documentCategory={documentCategory}
                      />
                    )
                  )}
                </Box>
              </Paper>
            </Grid>

            {/* Right Panel - PDF Viewer */}
            <Grid item xs={12} md={6}>
              <Paper elevation={3}>
                <Box p={3} borderBottom={1} borderColor="grey.300">
                  <Typography variant="h6">PDF View</Typography>
                </Box>
                <Box p={3}>
                  <PDFViewer schrockenCustomFileID={schrockenCustomFileID} />
                </Box>
              </Paper>
            </Grid>
          </Grid>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default ViewStructuredInformationBox;
